import axios from 'axios';
import store from '../store';
import router from '../router';
// Automatically detect API base URL
function getApiBaseUrl() {
    // Prefer environment variable
    if (process.env.VUE_APP_API_BASE_URL) {
        return process.env.VUE_APP_API_BASE_URL;
    }
    // If in browser environment, use current host with port 3000
    if (typeof window !== 'undefined') {
        const protocol = window.location.protocol;
        const hostname = window.location.hostname;
        return `${protocol}//${hostname}:3000`;
    }
    // Default value
    return 'http://localhost:3000';
}
const API_BASE_URL = getApiBaseUrl();
console.log('API Base URL:', API_BASE_URL);
const api = axios.create({
    baseURL: API_BASE_URL,
    timeout: 50000,
    headers: {
        'Content-Type': 'application/json',
    },
});
// Request interceptor
api.interceptors.request.use((config) => {
    const token = store.getters.token || localStorage.getItem('token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
}, (error) => {
    return Promise.reject(error);
});
// Response interceptor
api.interceptors.response.use((response) => {
    return response;
}, (error) => {
    // If we're on the Request RMA page, don't redirect on 401
    // This allows public forms to fail policy checks without kicking the user to login
    const isPublicForm = window.location.pathname.includes('/request-rma');
    if (error.response?.status === 401 && !isPublicForm) {
        store.dispatch('logout');
        // Only redirect if we are not already on the login page
        if (window.location.pathname !== '/login') {
            router.push('/login');
        }
    }
    const message = error.response?.data?.error || error.message || 'An error occurred';
    return Promise.reject(new Error(message));
});
export default api;
